import { useContext } from 'react';

import { ChipContext, type ChipContextProps } from './ChipContext.js';

/**
 * @internal
 */
export const useChipContext = (): ChipContextProps => useContext(ChipContext);
